export const CHEERIOS_V2_API_BASE_URL = import.meta.env.VITE_CHEERIOS_V2_API_BASE_URL || 'http://localhost:8000/remote';
export const CHEERIOS_V2_WS_BASE_URL = import.meta.env.VITE_CHEERIOS_V2_WS_BASE_URL || 'wss://localhost:8000/remote';